<template>
  <form ref="form" @submit.prevent="onSubmit">
    <div class="row g-3">
      <div class="col-sm-6">
        <label class="form-label">Nome</label>
        <input v-model="parceiro.nome" type="text" class="form-control" required>
      </div>
      <div class="col-sm-6">
        <label class="form-label">Telefone</label>
        <input
          ref="telefone"
          v-model="parceiro.telefone"
          v-maska="'(##) # ####-####'"
          type="tel"
          class="form-control"
          placeholder=" (99) 9 9999-9999"
          required
        >
      </div>
    </div>
    <div class="row g-3">
      <div class="col-sm-6">
        <label class="form-label">E-mail</label>
        <input v-model="parceiro.email" type="email" class="form-control" required>
      </div>
    </div>

    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
      <router-link to="/admin/parceiros" class="btn btn-secondary">
        <i class="bi bi-arrow-return-left" /> Voltar
      </router-link>
      <button class="btn btn-primary" @click="submit">
        <span class="bi bi-save">{{ $t("salvar") }}</span>
      </button>
    </div>
  </form>
</template>

<script>
import { vMaska } from 'maska/vue';
export default {
  directives: { maska: vMaska },
  props: {
    nome: { type: String, default: '' },
    telefone: { type: String, default: '' },
    email: { type: String, default: '' },
  },
  emits: ['salvar-parceiro', 'update:phone'],
  data: (props) => ({
    parceiro: {
      nome: props.nome,
      telefone: props.telefone,
      email: props.email,
    },
    phonePattern: '(##) ####-####',
  }),
  methods: {
    submit() {
      this.$refs.form.checkValidity() && this.save();
    },
    save() {
      this.parceiro.telefone = this.parceiro.telefone.replace(/[^\d]/g, '');
      this.$emit('salvar-parceiro', this.parceiro);
      this.$router.push('/admin/parceiros');
    },
  },
};
</script>
